import { schema as schemas } from 'normalizr'

import { CallApi } from '@signavio/kraken'

export const collection = 'inputDescriptors'

export const schema = new schemas.Array(
  new schemas.Entity(
    collection,
    {},
    {
      idAttribute: 'key',
    }
  )
)

type FetchParamsType = {
  actionId: string
  workflowId: string
}

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  ({ actionId, workflowId }: FetchParamsType) =>
    callApi(
      `${apiBase}/workflows/${workflowId}/actions/${actionId}/inputs`,
      schema
    )
